/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Location } from './Location';
import type { RoomStay } from './RoomStay';
export type UrlDetails = {
    PageType: UrlDetails.PageType;
    RoomStay?: RoomStay | null;
    HotelId?: number | null;
    PoiId?: number | null;
    CountryId?: number | null;
    Predicates?: any[] | null;
    Location?: Location | null;
    OrderBy?: UrlDetails.OrderBy;
    OrderDirection?: UrlDetails.OrderDirection;
};
export namespace UrlDetails {
    export enum PageType {
        LIST = 'list',
        HOTEL = 'hotel',
        POI_LIST = 'poiList',
        POI = 'poi',
        CUSTOM = 'custom',
        CHECKOUT = 'checkout',
    }
    export enum OrderBy {
        CHEAPEST_RATE = 'CheapestRate',
        CHEAPEST_PER_PERSON_PER_NIGHT_RATE = 'CheapestPerPersonPerNightRate',
        DISCOUNT_PERCENT = 'DiscountPercent',
        SCORE = 'Score',
        RATINGS_AVERAGE = 'RatingsAverage',
        TYPE = 'Type',
        RANKING_ORDER = 'RankingOrder',
        RATING = 'Rating',
        DISTANCE = 'Distance',
    }
    export enum OrderDirection {
        ASCENDING = 'Ascending',
        DESCENDING = 'Descending',
    }
}
